import { cn } from "@au-schein-de/au-ui-library";

export const PointIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={cn("text-ansay-400", className)}
		{...props}
	>
		<title>Checkmark</title>
		<rect width="20" height="20" rx="10" fill="currentColor" />
		<path
			d="M5.91797 10.0007L8.83464 12.9173L14.668 7.08398"
			stroke="white"
			stroke-width="1.16667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
